export class Constants {
  // FE page redirects
  public static readonly personalInfoRoute = '/register/personal-information';
  public static readonly completeDetailsRoute = '/register/complete-details';
  public static readonly activateAccountRoute = '/register/activate-account';
  public static readonly setupMfaRoute = '/setup-mfa';

  // Registration endpoints
  public static readonly signUpUrl = '/manage/accounts/v3/it-signup';
  public static readonly completeProfileUrl = '/manage/accounts/v3/it-complete-profile';

  // Fiscal code
  public static readonly getFiscalCodeDetailsUrl = '/manage/accounts/GetFiscalDetails';

  // Email activation
  public static readonly resendEmailActivationUrl =
    '/manage/accounts/v3/resend_invitation/{base64UserId}';
}
